"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var _suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var suplierCouponsApi = _suplierCouponsApi;
var appletApi = _interopRequireWildcard(require("@/views/business/clientManage/applet/api.js"));
var toolUtils = _interopRequireWildcard(require("@/utils/toolUtils.js"));
var _validate = require("@/utils/validate");
var _selectCompay = _interopRequireDefault(require("./selectCompay.vue"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _TimeSelect = _interopRequireDefault(require("./TimeSelect.vue"));
var _systemSetting = require("@/api/systemSetting.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MAX_IMAGE_SIZE = 2 * 1024 * 1024;
var MAX_IMAGE_SIZE_ERROR = '图片大小不能超过 2MB';
var _default = exports.default = {
  components: {
    SelectCompay: _selectCompay.default,
    TimeSelect: _TimeSelect.default
  },
  data: function data() {
    return {
      loading: false,
      addresData: [],
      pram: {},
      details: {},
      // 预留一份数据
      typeOpetion: [{
        value: 1,
        name: '待联系'
      }, {
        value: 2,
        name: '初次联系无回复'
      }, {
        value: 3,
        name: '资料收集'
      }, {
        value: 4,
        name: '商务洽谈'
      }, {
        value: 5,
        name: '签订合同'
      }, {
        value: 6,
        name: '合同终止'
      }],
      cardOpetion: [{
        value: 1,
        name: '无票'
      }, {
        value: 2,
        name: '普票'
      }, {
        value: 3,
        name: '专票'
      }, {
        value: 4,
        name: '混合票种'
      }],
      userOption: [],
      verificationOption: [{
        label: '小程序',
        value: 1
      }, {
        label: '扫码枪',
        value: 2
      }],
      //是否为小程序客户
      miniProgramCustomer: false,
      // 归属小程序列表
      customerOptions: [],
      // 核销链接选择器列表
      designAuthOptions: []
    };
  },
  props: {
    editId: [Number, String],
    supplierType: {
      type: [Number, String],
      default: 1 // 1-卡券 2-实物 3-家政 4-线下
    },
    showWriteOffType: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    editId: {
      handler: function handler(editId) {
        if (!editId) {
          this.initParams();
          return;
        }
        ;
        this.getDetail(editId);
      },
      immediate: true
    }
  },
  computed: {
    isOneCardSupplier: function isOneCardSupplier() {
      return Number(this.supplierType) === 6;
    }
  },
  created: function created() {
    this.miniProgramCustomer = suplierCouponsApi.getHomeType();
  },
  mounted: function mounted() {
    // this.getCityList();
    this.getSelectUser();
    this.loadCustomerOptions();
    this.loadDesignAuthOptions();
  },
  methods: {
    throttle: _throttle.default,
    initParams: function initParams() {
      this.pram = {
        ticketType: 1,
        // Default to "无票"
        settlementMethodText: '',
        // Initialize empty
        weChatGroupName: '',
        // Initialize empty
        writeOffType: this.isOneCardSupplier ? null : 1,
        discountRate: 100,
        // default 100%
        logo: '',
        miniProgramList: []
      };
    },
    getDefaultMiniProgramList: function getDefaultMiniProgramList() {
      return [{
        customerId: null,
        customerName: '',
        designAuthId: null,
        writeOffUrl: '',
        remark: '',
        status: 1
      }];
    },
    getDetail: function getDetail(id) {
      var _this = this;
      this.initParams();
      suplierCouponsApi.getComDetail(id).then(function (res) {
        var companyId = res.companyId,
          companyName = res.companyName;

        // Use settlementMethodText directly from the response
        // or use empty string as default
        var settlementMethodText = res.settlementMethodText || '';
        var miniProgramList = res.miniProgramList && res.miniProgramList.length ? res.miniProgramList.map(function (item) {
          return {
            id: item.id,
            customerId: item.customerId,
            customerName: item.customerName || (item.customerId ? '客户' + item.customerId : ''),
            designAuthId: item.designAuthId || null,
            writeOffUrl: item.writeOffUrl || '',
            remark: item.remark || '',
            status: item.status == null ? 1 : item.status
          };
        }) : [];
        _this.pram = _objectSpread(_objectSpread({}, res), {}, {
          companyId: "".concat(companyId, "_").concat(companyName),
          settlementMethodText: settlementMethodText,
          // 一卡通供应商无核销方式，其余供应商保持原有默认值。
          writeOffType: _this.isOneCardSupplier ? null : res.writeOffType || 1,
          logo: res.logo || '',
          miniProgramList: miniProgramList
        }) || {};
        // ensure discountRate exists
        if (_this.pram.discountRate === undefined || _this.pram.discountRate === null) {
          _this.pram.discountRate = 100;
        }
        console.log('pram', _this.pram);
        _this.details = JSON.parse(JSON.stringify(_this.pram));
      });
    },
    loadCustomerOptions: function loadCustomerOptions() {
      var _this2 = this;
      appletApi.getActiveCustomersApi().then(function (res) {
        _this2.customerOptions = res || [];
      }).catch(function () {
        _this2.customerOptions = [];
      });
    },
    loadDesignAuthOptions: function loadDesignAuthOptions() {
      var _this3 = this;
      suplierCouponsApi.getDesignAuthSelectList().then(function (res) {
        _this3.designAuthOptions = res || [];
      }).catch(function () {
        _this3.designAuthOptions = [];
      });
    },
    onDesignAuthChange: function onDesignAuthChange(val, item) {
      var opt = (this.designAuthOptions || []).find(function (o) {
        return o.designAuthId === val;
      });
      if (opt) {
        this.$set(item, 'writeOffUrl', opt.writeOffUrl || '');
      } else {
        this.$set(item, 'writeOffUrl', '');
      }
    },
    addMiniProgram: function addMiniProgram() {
      if (!this.pram.miniProgramList) {
        this.$set(this.pram, 'miniProgramList', []);
      }
      this.pram.miniProgramList.push(this.getDefaultMiniProgramList()[0]);
    },
    removeMiniProgram: function removeMiniProgram(idx) {
      this.pram.miniProgramList.splice(idx, 1);
    },
    onCustomerChange: function onCustomerChange(val, item) {
      var opt = (this.customerOptions || []).find(function (o) {
        return o.id === val;
      });
      if (opt) {
        this.$set(item, 'customerName', opt.name || '');
      }
    },
    beforeLogoUpload: function beforeLogoUpload(file) {
      var isImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg';
      if (!isImage) {
        this.$message.error('仅支持上传 png/jpg 格式图片！');
        return false;
      }
      if (file.size > MAX_IMAGE_SIZE) {
        this.$message.error(MAX_IMAGE_SIZE_ERROR);
        return false;
      }
      return true;
    },
    handleLogoUpload: function () {
      var _handleLogoUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(options) {
        var file, formData, loading, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = options.file;
              if (this.beforeLogoUpload(file)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              formData = new FormData();
              formData.append('multipart', file);
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.p = 2;
              _context.n = 3;
              return (0, _systemSetting.fileImageApi)(formData, {
                model: 'product',
                pid: 1
              });
            case 3:
              res = _context.v;
              loading.close();
              if (res && res.url) {
                this.$set(this.pram, 'logo', res.url);
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              loading.close();
              this.$message.error('上传失败：' + (_t.message || '请重试'));
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4]]);
      }));
      function handleLogoUpload(_x) {
        return _handleLogoUpload.apply(this, arguments);
      }
      return handleLogoUpload;
    }(),
    removeLogo: function removeLogo() {
      this.$set(this.pram, 'logo', '');
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this4 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        if (_this4.pram && _this4.pram.contactPhone && !toolUtils.isPhoneNumber(_this4.pram.contactPhone)) {
          _this4.$message.warning('请输入正确的手机号！');
          return;
        }
        ;
        _this4.loading = true;

        // 仅 supplierType=4 才处理 miniProgramList
        var isOffline = _this4.supplierType == 4;
        var rawMiniList = isOffline ? _this4.pram.miniProgramList || [] : [];
        var cleanMiniList = rawMiniList.filter(function (item) {
          // 过滤掉完全空白的行（没有任何有效数据的行）
          if (!item) return false;
          var hasCustomer = item.customerId != null;
          var hasDesignAuth = item.designAuthId != null;
          var hasWriteOffUrl = (item.writeOffUrl || '').trim();
          // 如果没有任何有效数据，则过滤掉
          if (!hasCustomer && !hasDesignAuth && !hasWriteOffUrl) return false;
          return true;
        }).map(function (item) {
          // 如果 writeOffUrl 为空，根据 designAuthId 查找对应的 writeOffUrl
          var writeOffUrl = (item.writeOffUrl || '').trim();
          if (!writeOffUrl && item.designAuthId) {
            var opt = (_this4.designAuthOptions || []).find(function (o) {
              return o.designAuthId === item.designAuthId;
            });
            if (opt) {
              writeOffUrl = opt.writeOffUrl || '';
            }
          }
          return {
            id: item.id || null,
            customerId: item.customerId,
            customerName: item.customerName || '',
            designAuthId: item.designAuthId || null,
            writeOffUrl: writeOffUrl,
            remark: item.remark || '',
            status: item.status == null ? 1 : item.status
          };
        });

        // Create a copy of the form data to modify before sending
        var formData = _objectSpread(_objectSpread({}, _this4.pram), {}, {
          supplierType: _this4.supplierType || 1,
          writeOffType: _this4.isOneCardSupplier ? null : _this4.pram.writeOffType,
          // Ensure discountRate is a number and present
          discountRate: _this4.pram.discountRate === undefined || _this4.pram.discountRate === null ? 100 : Number(_this4.pram.discountRate),
          // Remove old fields if they exist
          settlementMethod: undefined,
          settlementMethodDesc: undefined,
          logo: _this4.pram.logo || '',
          miniProgramList: isOffline ? cleanMiniList : undefined
        });
        console.log('formData', formData);
        suplierCouponsApi[_this4.editId ? 'UpdateArticle' : 'AddArticle'](formData).then(function (data) {
          _this4.$message.success('编辑成功');
          _this4.loading = false;
          _this4.$emit('hideDialog');
        }).catch(function () {
          _this4.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.$emit('closeEdit');
    },
    getCityList: function getCityList() {
      var _this5 = this;
      this.addresData = [];
      logistics.treeLevel3().then(function (res) {
        _this5.addresData = res;
      }).catch(function (res) {
        _this5.$message.error(res.message);
      });
    },
    selectCompany: function selectCompany(companyId) {
      this.pram = _objectSpread(_objectSpread({}, this.pram), {}, {
        companyId: companyId
      });
    },
    // 查询当前登陆人
    getSelectUser: function getSelectUser(keyWord) {
      var _this6 = this;
      this.userOption = [];
      suplierCouponsApi.getAllUser(keyWord).then(function (res) {
        _this6.userOption = res || []; //flag: 1表示当前登陆人
      });
    },
    handleUserSearch: function handleUserSearch(data) {
      var _this7 = this;
      this.throttle(function () {
        _this7.getSelectUser(data);
      }, 300)();
    }
  }
};